import { SearchParams } from '@/constants/listing-search-keys';
import { ListingQueryProps } from 'types/listing-query-props';

/** URL value indicating the user explicitly chose all resorts (no filter). */
export const ALL_RESORTS_PARAM_VALUE = 'all';

export const isAllResortsParam = (
  value: string | null | undefined
): boolean => value === ALL_RESORTS_PARAM_VALUE;

export const hasExplicitResortSearchParam = (
  searchParams: Pick<ListingQueryProps, 'resort_id'> | URLSearchParams
): boolean => {
  if (searchParams instanceof URLSearchParams) {
    return searchParams.has(SearchParams.RESORT);
  }

  return searchParams.resort_id != null;
};

/** Returns a resort id for API filters, or undefined when all resorts are selected. */
export const resolveResortFilterId = (
  resortId: string | null | undefined
): string | undefined =>
  resortId && !isAllResortsParam(resortId) ? resortId : undefined;
